export enum EMasterSondeType {
    PH = 1,
    Oxygene = 2,
    Conductivite = 3
}